import React from 'react';
import { createRoot } from 'react-dom/client';
import AlertModal from '../components/AlertModal';

let container = null;
let root = null;

function ensureContainer() {
  if (!container) {
    container = document.createElement('div');
    container.id = 'global-alert-container';
    document.body.appendChild(container);
    root = createRoot(container);
  }
}

export function showAppAlert(type, message, title) {
  ensureContainer();
  const handleClose = () => {
    if (root) {
      root.render(null);
    }
  };

  root.render(
    <AlertModal open type={type} title={title} message={message} onClose={handleClose} />
  );
}


